
import React, {useState, useEffect} from 'react';


function App() {  

  const [events, setEvents] = useState([]);

  useEffect(() => {   
    
    fetchEvents()
  },[]);

  function fetchEvents(){
  
    fetch('./configs/events.json', {cache:"no-cache"})
    .then(response => response.json()) 
    .then(events => {
      console.log(events)
      setEvents(events)
    }).catch();
  
  }


  


    return (
      events!=undefined?
        <div className="component-view-colum animate" data-animate="blendin 3s">
        {
         events.map((element) => {
          if(element.visible){
          return <div className='event-view'>
                <div className="text-item text-center text-header"> 
                  {element.title}
                  
                </div>  
                <div className="text-item text-center">{element.location}</div>
        <div className="text-item text-center">{element.time}</div>

        {
          element.descriptions.map(item=>(
            item ==="" ? <div> <br/> </div>:<div className="text-item text-center">{item}</div>
          ))
        }
        
        {
          element.img!=undefined&&element.img!=""? 
        
        <div>
          <img class='event-img' src={element.img}/>
        </div>:null
               } 
                </div>}
          })
        }

      
      
        
      </div>:null
            );
        }
    
    export default App;